import { useFeatureFlag } from './useFeatureFlag';

/**
 * Hook for managing gamification-related state and functionality
 * Provides a centralized way to check if gamification features are enabled
 * and access gamification-related utilities
 */
export function useGamification() {
  const { isEnabled } = useFeatureFlag();

  /**
   * Check if gamification features are enabled
   */
  const isGamificationEnabled = isEnabled('GAMIFICATION_ENABLED');

  /**
   * Check if a specific gamification feature should be shown
   * This allows for granular control over different gamification elements
   */
  const shouldShowCoins = isGamificationEnabled;
  const shouldShowBadges = isGamificationEnabled;
  const shouldShowLeaderboard = isGamificationEnabled;
  const shouldShowProgress = isGamificationEnabled;
  const shouldShowRewards = isGamificationEnabled;

  return {
    isGamificationEnabled,
    shouldShowCoins,
    shouldShowBadges,
    shouldShowLeaderboard,
    shouldShowProgress,
    shouldShowRewards,
  };
}